(function () {
  // ADR-260 §4.4 — the customer's search history on the web (owner's addition
  // to the customer 360 file). One event per EXECUTED search of a signed-in
  // customer: the results page (/search?q=) or a click on a dropdown result —
  // never per keystroke. Guests send nothing. The worker drops a repeat of the
  // same term within 60 s; this file skips it client-side too.
  var PATH = '/v1/customer/search-event';
  var REPEAT_MS = 60000;
  var last = { term: '', at: 0 };

  /** Control/format characters removed (NUL, zero-width, bidi overrides), whitespace collapsed, ≤ 80 chars; '' when shorter than 2. Same rule as the worker. */
  function normalizeTerm(raw) {
    var t = String(raw == null ? '' : raw).replace(/[\p{Cc}\p{Cf}]/gu, ' ').replace(/\s+/g, ' ').trim().slice(0, 80).trim();
    return Array.from(t).length >= 2 ? t : '';
  }

  /** Whether to send now (and remember it): a new term, or the same one after REPEAT_MS. */
  function shouldSend(state, term, nowMs) {
    if (!term) return false;
    if (state.term === term && nowMs - state.at < REPEAT_MS) return false;
    state.term = term;
    state.at = nowMs;
    return true;
  }

  /** The term of a results page URL (`/search?q=…`, any locale prefix), else ''. */
  function termFromLocation(loc) {
    if (!/\/search\/?$/.test(loc.pathname || '')) return '';
    var m = /[?&]q=([^&]*)/.exec(loc.search || '');
    if (!m) return '';
    try {
      return normalizeTerm(decodeURIComponent(m[1].replace(/\+/g, ' ')));
    } catch (e) {
      return '';
    }
  }

  function record(raw) {
    var term = normalizeTerm(raw);
    if (!window.ErosSession || !window.ErosSession.isSignedIn || !window.ErosSession.isSignedIn()) return;
    if (!window.ErosCommerce || !window.ErosCommerce.request) return;
    if (!shouldSend(last, term, Date.now())) return;
    window.ErosCommerce.request(PATH, { method: 'POST', auth: true, body: { term: term, source: 'web' } }).catch(function () {
      /* best effort — search never waits on history */
    });
  }

  window.ErosSearchEvent = { record: record, normalizeTerm: normalizeTerm, shouldSend: shouldSend, termFromLocation: termFromLocation };

  function onResultsPage() {
    if (typeof location === 'undefined') return;
    var term = termFromLocation(location);
    if (term) record(term);
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onResultsPage);
    else onResultsPage();
  }
})();
